{
  "version": 1,
  "asset_id": "59ae49e8-36d8-4d5e-817f-f250a9555f98",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/59ae49e8-36d8-4d5e-817f-f250a9555f98/pool-booking-parallax.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/59ae49e8-36d8-4d5e-817f-f250a9555f98/pool-booking-parallax.webp",
  "original_filename": "pool-booking-parallax.webp",
  "size": 185892,
  "content_type": "image/webp",
  "created_at": "2026-07-04T16:12:57Z"
}
